import { publicProfile } from './Public/publicProfile';
import {privateProfile} from "./Private/privateProfile";
import {private2Profile} from "./Private2/private2Profile";
import {initialProfile} from "./Initial/initialProfile";

export const profiles = [publicProfile, privateProfile, private2Profile, initialProfile];
